import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiArrowRight, FiShield } = FiIcons;

const PasswordGate = ({ onVerify, onDenied }) => {
  const [password, setPassword] = useState('');
  const CORRECT_PASSWORD = 'Harl33@';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      onVerify();
    } else {
      onDenied();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-indigo-900 p-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white/10 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/20"
      >
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiShield} className="text-3xl text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white">Secure Access</h2>
          <p className="text-blue-100/70">Please enter your password to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <SafeIcon icon={FiLock} className="text-blue-200" />
            </div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white/10 border border-white/20 text-white placeholder-blue-200/50 pl-11 pr-4 py-4 rounded-2xl focus:ring-2 focus:ring-white/50 focus:border-transparent outline-none transition-all"
              placeholder="Enter password"
              required
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            className="w-full flex items-center justify-center gap-2 bg-white text-indigo-900 py-4 rounded-2xl font-bold shadow-xl hover:bg-blue-50 transition-all"
          >
            Enter App
            <SafeIcon icon={FiArrowRight} />
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default PasswordGate;